import React from "react";
import { Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { Sparkles, ArrowRight } from "lucide-react";
import { StatusBadge, Button } from "@/components/ds";
import { api } from "@/lib/api";

const SEV_TONE: Record<string, string> = { high: "red", medium: "amber", low: "slate" };

export function Recommendations() {
  const { data } = useQuery({ queryKey: ["optimization", "dashboard"], queryFn: () => api.optimization({ limit: "3" }) });
  if (!data || !data.available || data.recommendations.length === 0) return null;

  return (
    <div className="rounded-xl border border-slate-200 bg-white shadow-sm" data-testid="dashboard-recommendations">
      <div className="flex items-center justify-between border-b border-slate-100 px-5 py-3.5">
        <div className="flex items-center gap-2 text-sm font-semibold text-slate-800">
          <Sparkles className="h-4 w-4 text-blue-500" /> ResFil Recommendations
        </div>
        <Link to="/app/optimization"><Button size="sm" variant="ghost" data-testid="dashboard-recs-all">View all <ArrowRight className="h-4 w-4" /></Button></Link>
      </div>
      <ul className="divide-y divide-slate-100">
        {data.recommendations.map((r) => (
          <li key={r.key} className="flex items-start justify-between gap-3 px-5 py-3.5" data-testid={`dashboard-rec-${r.key}`}>
            <div className="min-w-0">
              <p className="text-sm font-medium text-slate-900">{r.title}</p>
              <p className="mt-0.5 line-clamp-1 text-xs text-slate-500">{r.evidence}</p>
            </div>
            <StatusBadge tone={SEV_TONE[r.severity] as any}>{r.severity}</StatusBadge>
          </li>
        ))}
      </ul>
    </div>
  );
}
